import React from "react";

/**
 * BetaBadge — small pill that sits next to the "Kalib AI" wordmark to signal
 * pre-release status. Kept intentionally minimal and uppercase.
 *
 * Visual: amber-700 outline + amber-700 text, tracking-wider, 10px font, 4px
 * vertical / 6px horizontal padding. Aligned vertically with logo baseline.
 */
export const BetaBadge = ({ className = "" }) => (
  <span
    data-testid="beta-badge"
    className={
      "inline-flex items-center align-middle border border-amber-700 text-amber-700 " +
      "uppercase font-semibold tracking-wider text-[10px] leading-none px-1.5 py-0.5 " +
      "rounded-sm select-none " +
      className
    }
  >
    Beta
  </span>
);

export default BetaBadge;
